import type { MembershipTrendDto } from '../../../api/engagementMetrics';

interface MembershipTrendsCardProps {
  trends: MembershipTrendDto[];
}

const COLOR_UP = '#2e7d32';
const COLOR_DOWN = '#c62828';
const COLOR_ZERO = '#888';

function trendColor(direction: MembershipTrendDto['trendDirection']): string {
  if (direction === 'up') return COLOR_UP;
  if (direction === 'down') return COLOR_DOWN;
  return COLOR_ZERO;
}

function formatTrend(direction: MembershipTrendDto['trendDirection'], pct: number): string {
  if (direction === 'zero') return '0%';
  const sign = direction === 'up' ? '+' : '';
  return `${sign}${pct.toFixed(1)}%`;
}

// AC20, AC21 — membership trends panel
export function MembershipTrendsCard({ trends }: MembershipTrendsCardProps) {
  return (
    <div
      data-testid="membership-trends-card"
      style={{
        background: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        padding: '12px',
        marginTop: '12px',
      }}
    >
      <div
        style={{
          fontSize: '11px',
          fontWeight: 700,
          textTransform: 'uppercase',
          color: '#333',
          marginBottom: '8px',
          letterSpacing: '0.5px',
        }}
      >
        Membership Trends
      </div>
      {trends.length === 0 && (
        <div style={{ fontSize: '12px', color: '#999' }}>No BRGs in scope.</div>
      )}
      {trends.map(t => (
        <div
          key={t.brgId}
          data-testid={`trend-row-${t.brgId}`}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 0',
            fontSize: '12px',
            borderBottom: '1px solid #f5f5f5',
          }}
        >
          <span style={{ color: '#333' }}>{t.brgName}</span>
          <span
            data-testid={`trend-value-${t.brgId}`}
            style={{ color: trendColor(t.trendDirection), fontWeight: 600 }}
          >
            {formatTrend(t.trendDirection, t.trendPercent)}
          </span>
        </div>
      ))}
    </div>
  );
}
